module.exports = __webpack_public_path__ + "img/clock2.da2a7cd1.svg";